/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { FormError, FormHeader } from '@exo/frontend-components-forms';
import { FluidForm } from 'carbon-components-react';
import React, { useState } from 'react';
import { FieldValues, UseFormHandleSubmit } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import * as S from './PolarisLoginBaseForm.styles';

export const PolarisLoginBaseForm = React.forwardRef<HTMLFormElement>(
  ({ onSubmit, onError, children, form, error, ref }: Props) => {
    const [submitError, setSubmitError] = useState(undefined);

    const onSubmitWithErrorHandling = d =>
      Promise.resolve(onSubmit(d)).catch(e => setSubmitError(e.message));

    return (
      <S.PolarisLoginBase>
        <FluidForm
          method="post"
          onSubmit={form.handleSubmit(onSubmitWithErrorHandling, onError)}
          itemRef={ref}
        >
          {(error || submitError) && (
            <S.ErrorWrapper>
              <FormHeader>
                <FormError titleText="">{error ?? submitError}</FormError>
              </FormHeader>
            </S.ErrorWrapper>
          )}
          {children}
        </FluidForm>
      </S.PolarisLoginBase>
    );
  }
);

type Props = {
  intlPrefix?: string;
  children?: any;
  data?: any;
  schema?: ObjectSchema;
  idPrefix?: string;
  onChange?: (data: any) => void;
  onSubmit: (data: any) => void;
  onError?: (error: any) => void;
  error?: string;
  form: {
    handleSubmit: UseFormHandleSubmit<FieldValues>;
  };
  ref?: any;
};
